// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Omni Environments API
 * API to manage Omni Development Environments
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const FieldOperator = {
  OpIn: 'In',
  OpNotIn: 'NotIn',
  OpExists: 'Exists',
  OpDoesNotExist: 'DoesNotExist',
} as const;
export type FieldOperator = (typeof FieldOperator)[keyof typeof FieldOperator];

export function instanceOfFieldOperator(value: any): boolean {
  for (const key in FieldOperator) {
    if (Object.prototype.hasOwnProperty.call(FieldOperator, key)) {
      if (FieldOperator[key as keyof typeof FieldOperator] === value) {
        return true;
      }
    }
  }
  return false;
}

export function FieldOperatorFromJSON(json: any): FieldOperator {
  return FieldOperatorFromJSONTyped(json, false);
}

export function FieldOperatorFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): FieldOperator {
  return json as FieldOperator;
}

export function FieldOperatorToJSON(value?: FieldOperator | null): any {
  return value as any;
}

export function FieldOperatorToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): FieldOperator {
  return value as FieldOperator;
}
